import { CatButton } from 'components/blocks-components';

type DealerNotificationErrorToastProps = {
  contactUsLink: string;
  contactUsText: string;
};
export const DealerNotificationErrorToast = ({
  contactUsLink,
  contactUsText
}: DealerNotificationErrorToastProps) => {
  return (
    <div className="mt-2">
      <CatButton size="sm" href={contactUsLink}>
        <span className="text-capitalize">{contactUsText}</span>
      </CatButton>
    </div>
  );
};
